export const environment = {
  global: {
    production: false,
    firebaseConfig: {
      apiKey: 'AIzaSyDzL7ZvVrSAHV9rV_h0cY4iQYGv3o6I8R4',
      authDomain: 'localhost',
      projectId: 'synth365-ths',
      storageBucket: 'synth365-ths.firebasestorage.app',
      messagingSenderId: '870259539358',
      appId: '1:870259539358:web:d14bc1f4d23641c6676a8f',
      measurementId: 'G-DZZRED0HB7',
    },
    basePath: 'https://med.synth365.com/',

    pos_base_url: `https://inv-pos-smbtclinics.beta.synth365.com/`,
    hr_base_url: `https://hr-app.beta.synth365.com/`,
    // masterPath: 'http://localhost:3001/',
    // opdPath: 'http://localhost:3000/',
    // ipdPath: 'http://localhost:3002/',

    masterPath: 'https://med.synth365.com/master_service/',
    opdPath: 'https://med.synth365.com/opd_service/',
    ipdPath: 'https://med.synth365.com/ipd_service/',
    baseReport_Path: 'http://crystalreportserver.synth365.com:88/SQLReport',
    // complaint beta env
    baseApiPathComplaint: 'https://beta.smbtecampus.org:8091/api/',
    //schoolERP_FeedbackForm
    apiUrlFeedback: 'https://api-baseservice-beta.synth365.com',
    complaintFilePath: 'https://s3-cms-prod-smbt.s3.ap-south-1.amazonaws.com/', // file path for complaint images
    baseApiPathComplaintFullUrl: 'https://beta.smbtecampus.org:8091/api/',
    baseReportPath_New:
      'https://api-report-prod-smbt.synth365.com/reportMaster/getReport',
    // baseReport_Path: KEY_PRINT_CONFIG.basePath_SERVER,
    baseReport_Folder: 'RegistrationReport',
    baseBillReport_Folder: 'BillingReport',
    baseInventoryReport_Folder: 'InventoryReport',
    baseReportConsole_Folder: 'ReportConsole',
    basePathologyFolder: 'PathologyReport',
    baseOtFolder: 'OTReport',
    baseEmrRportFolder: 'EmrReport',
  },

  // BETA: {
  //   production: true,
  //   firebaseConfig: {
  //     apiKey: 'AIzaSyBT8UJRu7sSZAa4TShVUb4uJLGpGd51W_U',
  //     authDomain: 'synth365-ths.firebaseapp.com',
  //     projectId: 'synth365-ths',
  //     storageBucket: 'synth365-ths.appspot.com',
  //     messagingSenderId: '870259539358',
  //     appId: '1:870259539358:web:318d6c10f5c2d395676a8f',
  //     measurementId: 'G-DTHKFPG5DE',
  //   },
  //   OPENAI_API_KEY: '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',

  //   pos_base_url: `https://inv-pos-smbtclinics.beta.synth365.com/`,
  //   hr_base_url: `https://hr-app.beta.synth365.com/`,
  //   reportUrlPath:
  //     'https://api-report-prod-smbt.synth365.com/reportMaster/getReport',

  //   // Microservices : beta
  //   masterPath: 'https://med.synth365.com/master_service/',

  //   opdPath: 'https://med.synth365.com/opd_service/',
  // },

  SMBT_CLINICS: {
    production: true,
    firebaseConfig: {
      apiKey: 'AIzaSyDzL7ZvVrSAHV9rV_h0cY4iQYGv3o6I8R4',
      authDomain: 'synth365-ths.firebaseapp.com',
      projectId: 'synth365-ths',
      storageBucket: 'synth365-ths.firebasestorage.app',
      messagingSenderId: '870259539358',
      appId: '1:870259539358:web:d14bc1f4d23641c6676a8f',
      measurementId: 'G-DZZRED0HB7',
    },
    OPENAI_API_KEY: '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',
    basePath: 'https://api-hmis-clinics-prod.synth365.com/',

    pos_base_url: `https://inv-pos-smbtclinics.beta.synth365.com/`,
    hr_base_url: `https://hr-app.beta.synth365.com/`,

    // Microservices : new paths smbt clinics prod
    masterPath: 'https://api-hmis-clinics-prod.synth365.com/master_service/',
    opdPath: 'https://api-hmis-clinics-prod.synth365.com/opd_service/',
    ipdPath: 'https://api-hmis-clinics-prod.synth365.com/ipd_service/',
    baseReportPath_New:
      'https://api-report-prod-smbt.synth365.com/reportMaster/getReport',
    baseReport_Folder: 'RegistrationReport',
    baseBillReport_Folder: 'BillingReport',
    baseInventoryReport_Folder: 'InventoryReport',
    baseReportConsole_Folder: 'ReportConsole',
    basePathologyFolder: 'PathologyReport',
    baseOtFolder: 'OTReport',
    baseEmrRportFolder: 'EmrReport',
  },
};
